export const DEFAULT_CANVAS_HEIGHT = 200
export const EMPTY_INITIAL_ANSWER = '__________'
